import { withTranslation } from "react-i18next";

import React from 'react';
import { Link, } from 'react-router-dom';
import Pagination from "react-js-pagination";
import Products from '../../Models/Products';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
var striptags = require('striptags');

class SubCategoriesShowProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsCountPerPage: 10,
            pageRangeDisplayed: '',
            categories: [],
            allCategories: [],
            categoriesName: [],
            categoryProducts: [],
            allProducts: [],
            total: [],
            // id: this.props.id,

        };
        // console.log(this.props)
        // this.getTotal();
        this.getAllProducts(this.props.id);
        this.getAllCategories(this.props.id);
        this.getCategoriesName(this.props.id);
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.id!== prevProps.id){
            this.getAllProducts(this.props.id);
            this.getAllCategories(this.props.id);
            this.getCategoriesName(this.props.id);
            console.log("component update", this.state.allProducts);
        }
    }

    getAllProducts(id) {
        let affId = JSON.parse(localStorage.getItem('aff-id'))
        if (affId > 0) {
            Products.getAffiliatorSubProducts(id, 1).then(res => {
                if (res.data.payload != null) {
                    this.setState({ allProducts: res.data.payload, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total })
                    console.log("api updated: ", this.state.allProducts);
                }
                else{
                    this.setState({ allProducts: [], pageRangeDisplayed: '', itemsCountPerPage: 10, total: []})
                }
            })
        } else {
            Products.getSubProducts(id, 1).then(res => {
                if (res.data.status === 200) {
                    this.setState({ allProducts: res.data.payload, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total })
                } else {
                    this.setState({ allProducts: [], pageRangeDisplayed: '', itemsCountPerPage: 10, total: []})
                }
            })
        }
    }

    getTotal() {
        let affId = JSON.parse(localStorage.getItem('aff-id'))
        if (affId > 0) {
            Products.getAffiliatorSubProducts(this.props.id, 1).then(res => {
                if (res.data.payload != null) {
                    this.setState({ total: res.data })
                }
            })
        } else {
            Products.getSubProducts(this.props.id, 1).then(res => {
                this.setState({ total: res.data })
            })
        }
    }

    getAllCategories(id) {
        Products.getSubProducts(id, 1).then(res => {
            if (res.data.status === 200) {
                this.setState({ allCategories: res.data.cat_name })
            }
        })
    }

    getCategoriesName(id) {
        Products.getCategoryName(id).then(res => {
            if (res.data.status === 200) {
                this.setState({ categoriesName: res.data.payload })
            }
        })
    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }

    toggleAll() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    handlePageChange(pageNumber) {
        let affId = JSON.parse(localStorage.getItem('aff-id'))
        if (affId > 0) {
            Products.getAffiliatorSubProducts(this.state.id, pageNumber).then(res => {
                if (res.data.payload != null) {
                    this.setState({ allProducts: res.data.payload, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total })
                }
            })
        } else {
            Products.getSubProducts(this.state.id, pageNumber).then(res => {
                this.setState({ allProducts: res.data.payload })
                this.setState({ activePage: pageNumber, pageRangeDisplayed: this.state.pageRangeDisplayed, itemsCountPerPage: this.state.itemsCountPerPage, total: res.data.total });
            })
        }
    }

    sellerName(name, id) {
        if (!localStorage.getItem('info')) {
            return (
                <div className="">
                    <div style={{ textAlign: 'center', color: '#007bff' }} className="" onClick={this.toggleAll.bind(this)}>{name}</div>
                    <Modal isOpen={this.state.modal} toggle={this.toggleAll.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggleAll.bind(this)}></ModalHeader>
                        <ModalBody>
                            {this.props.t('0')}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggleAll.bind(this)}>{this.props.t('1')}</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        } else {
            return (
                // <div className="">
                <Link to={{ pathname: `/my-profile-view/users/${id}`, state: { id: id } }} style={{ textAlign: 'center', fontSize: '13px' }} className="">
                    {name}
                </Link>
                //</div>
            )
        }
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                striptags(details)
            )
        } else {
            return (
                striptags(details.substr(0, 150))
            )
        }
    }

    range() {
        if (this.state.total > 0) {
            return (
                <div className="some_of_total pl-4" >
                    <span>{this.state.total}{this.props.t('2')} 1-{this.state.total} {this.props.t('5')}</span>
                </div>
            )
        } else {
            return (
                <div className="some_of_total pl-4" >
                    {/* <span>{this.state.total}{this.props.t('2')} 1-{this.state.total} {this.props.t('5')}</span> */}
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <div className="large_fonts">
                        <div style={{ minHeight: "700px" }}>
                            {/* {this.state.categoriesName.map((res, i) => */}
                            <div className="big_text guide_text" style={{ paddingBottom: '10px', width: '100%' }}>
                                {this.state.categoriesName.cat_name}
                            </div>
                            {/* )} */}
                            {this.range()}
                            {/* <div className="some_of_total pl-4" >
                                <span>{this.state.total}{this.props.t('2')} 1-{this.state.total} {this.props.t('5')}</span>
                            </div> */}
                            <div className="" >
                                {this.state.allProducts.map(pro =>
                                    <div className="" key={pro.id} >
                                        <div style={{ border: "1px solid #f4f2f0", padding: '3%' }}>
                                            <div className="row">
                                                <div className="col-md-9 remember_text">
                                                    <div className="row pb-2">
                                                        <div className=" col-8 ">
                                                            {this.sellerName(pro.seller, pro.seller_id)}
                                                        </div>
                                                        <div className="col-4 text-center">
                                                            <span>{parseInt(pro.price)}</span> {this.props.t('8')}
                                                </div>
                                                    </div>
                                                    <Link to={{
                                                        pathname: `/categories-details/${pro.id}`,
                                                        state: { id: pro.id }
                                                    }}
                                                        style={{ textDecoration: "none" }}>
                                                        <span className="category-right"><b>{pro.title}</b></span><br />

                                                    </Link>
                                                    <span className="diff_font category-right">{pro.short_desc}</span>

                                                    <div className="product_description" style={{ fontSize: '12' }}>
                                                        {this.details(pro.long_desc)}
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <img src={pro.img} alt="" style={{ width: "100%", height: "100", objectFit: 'cover' }} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {(() => {
                        if (this.state.allProducts.length < 10) {
                            return (
                                <div></div>
                            )
                        } else {
                            return (
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-6" style={{ fontSize: "15px" }}>
                                        <Pagination
                                            hideNavigation
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.itemsCountPerPage}
                                            totalItemsCount={this.state.total}
                                            pageRangeDisplayed={this.state.pageRangeDisplayed}
                                            onChange={this.handlePageChange.bind(this)}
                                        />
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                            )
                        }
                    })()}
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <div className="container-fluid pl-4">
                        <div className="large_fonts">
                            <div style={{ minHeight: "700px" }}>
                                {/* {this.state.categoriesName.map(res => */}
                                <div className="col-md-12" >
                                    <div className="guide_text" style={{ width: '100%' }}>
                                        {this.state.categoriesName.cat_name}
                                    </div>
                                </div>
                                {/* )} */}
                                {this.range()}
                                <div className="custom_padding_dash" style={{ paddingLeft: '3%' }}>
                                    {this.state.allProducts.map(pro =>
                                        <div className="row " key={pro.id} >
                                            <div className="col-md-9 remember_text">
                                                <Link to={{
                                                    pathname: `/categories-details/${pro.id}`,
                                                    state: { id: pro.id }
                                                }}
                                                    style={{ textDecoration: "none" }}>
                                                    <span className="category-right"><b>{pro.title}</b></span><br />

                                                </Link>
                                                <span className="diff_font category-right">{pro.short_desc}</span>

                                                <div className="product_description" style={{ fontSize: '12' }}>
                                                    {this.details(pro.long_desc)}
                                                </div>
                                                <div className="mt-1 col-md-12 stars">
                                                    <div className=" row ">
                                                        {this.sellerName(pro.seller, pro.seller_id)}
                                                    </div>
                                                    &nbsp;&nbsp;
                                            </div>
                                            </div>
                                            <div className="col-md-3">
                                                <img src={pro.img} alt="" style={{ width: "100%", height: "55%", objectFit: 'cover' }} />
                                                <br />
                                                <div className="mt-3 pl-3">
                                                    <span>{parseInt(pro.price)}</span> {this.props.t('8')}
                                            </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        {(() => {
                            if (this.state.allProducts.length < 10) {
                                return (
                                    <div></div>
                                )
                            } else {
                                return (
                                    <div className="row">
                                        <div className="col-md-4"></div>
                                        <div className="col-md-6" style={{ fontSize: "15px" }}>
                                            <Pagination
                                                hideNavigation
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.itemsCountPerPage}
                                                totalItemsCount={this.state.total}
                                                pageRangeDisplayed={this.state.pageRangeDisplayed}
                                                onChange={this.handlePageChange.bind(this)}
                                            />
                                        </div>
                                        <div className="col-md-2"></div>
                                    </div>
                                )
                            }
                        })()}

                    </div>
                </div>
            )
        }
    }
}
export { SubCategoriesShowProducts }

 SubCategoriesShowProducts = withTranslation('src_Components_Categories_SubCategoriesShowProducts')(SubCategoriesShowProducts);
